import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4c8574ec&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=4c8574ec&prod&lang=scss&scoped=true"
import style1 from "./Edit.vue?vue&type=style&index=1&id=4c8574ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8574ec",
  null
  
)

export default component.exports